'use client';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { BaseModal } from '../BaseModal/BaseModal';
import { BasePrimaryButton } from '../../Buttons/BasePrimaryButton/BasePrimaryButton';
import styles from './DeleteAccountModal.module.css';

interface DeleteAccountModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => Promise<void>;
	isLoading?: boolean;
}

export const DeleteAccountModal = ({
	isOpen,
	onClose,
	onConfirm,
	isLoading,
}: DeleteAccountModalProps) => {
	const handleSubmit = async () => {
		try {
			await onConfirm();
			onClose();
		} catch {
			return;
		}
	};

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Excluir Conta"
			isLoading={isLoading}
			actions={
				<>
					<button
						className={styles.cancelButton}
						onClick={onClose}
						disabled={isLoading}
						type="button"
					>
						Cancelar
					</button>
					<BasePrimaryButton
						onClick={handleSubmit}
						disabled={isLoading}
						className={styles.deleteButton}
					>
						Excluir Minha Conta
					</BasePrimaryButton>
				</>
			}
		>
			<div className={styles.content}>
				<div className={styles.warningBox}>
					<WarningAmberOutlinedIcon className={styles.warningIcon} />
					<p className={styles.warningText}>
						Sua conta será <strong>bloqueada imediatamente</strong> e os dados excluídos
						definitivamente após o prazo de carência. Dentro desse prazo, você pode reativar a
						conta tentando fazer login novamente.
					</p>
				</div>

				<div className={styles.consequences}>
					<h4 className={styles.consequencesTitle}>O que será perdido</h4>
					<ul className={styles.list}>
						<li>Todos os seus dados pessoais e de contato</li>
						<li>Histórico completo de atividades</li>
						<li>Relatórios, análises e configurações</li>
						<li>Acesso permanente à plataforma</li>
					</ul>
				</div>
			</div>
		</BaseModal>
	);
};
